// Models
import Model from './Model'
import ForexCurrencyRate from './ForexCurrencyRate'

class ForexCurrencyPair extends Model {
  get schema () {
    return [
      'fromCurrency',
      'toCurrency',
      'buy',
      'sell',
      'useAutoRate'
    ]
  }

  get formatters () {
    return {
      buy: (data) => new ForexCurrencyRate(data),
      sell: (data) => new ForexCurrencyRate(data)
    }
  }
}

export default ForexCurrencyPair
